import {
  useReducer,
  useEffect,
  useContext,
} from "react";
import FormControl from "../UI/FormControl";
import Button from "../UI/Button";
import styles from "./LoginForm.module.css";
import { AuthContext } from "../../store/auth-context";
import { formDefaultState } from "../../Reducers/FormDefaultState";
import FormReducer from "../../Reducers/FormReducer";
const LoginForm = () => {
  //* states
  const [formState, dispatchForm] = useReducer(
    FormReducer,
    formDefaultState
  );
  const changeEmailHandler = (event) => {
    const value = event.target.value;
    dispatchForm({
      type: "EMAIL_INPUT",
      value,
    });
  };

  const changePasswordHandler = (event) => {
    const value = event.target.value;
    dispatchForm({
      type: "PASSWORD_INPUT",
      value,
    });
  };

  //*context
  const authCtx = useContext(AuthContext);
  const clickSignUpHandler = () => {
    authCtx.onSaveLoginState(false, false, "");
    authCtx.onSignUp(true);
  };

  //*validity
  const {
    emailIsValid,
    passwordIsValid,
    formIsValid,
  } = formState;

  const submitFormHandler = (event) => {
    event.preventDefault();
    const loginDetails = {
      email: formState.emailValue,
      password: formState.passwordValue,
    };
    authCtx.onLogin(loginDetails);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatchForm({ type: "FORM_VALIDITY" });
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [emailIsValid, passwordIsValid]);
  return (
    <form
      onSubmit={submitFormHandler}
      className={styles.form}
    >
      <div className={styles["form-controls"]}>
        <FormControl
          Input={{
            type: "email",
            id: "email",
            value: formState.emailValue,
            onChange: changeEmailHandler,
          }}
          Label={{
            child: { label: "E-Mail" },
            properties: {
              htmlFor: "email",
            },
          }}
          className={`${styles["form-control"]} ${
            emailIsValid ? "" : styles["invalid"]
          }`}
        />
        <FormControl
          Input={{
            type: "password",
            id: "password",
            value: formState.passwordValue,
            onChange: changePasswordHandler,
          }}
          Label={{
            child: { label: "Password" },
            properties: {
              htmlFor: "password",
            },
          }}
          className={`${styles["form-control"]} ${
            passwordIsValid
              ? ""
              : styles["invalid"]
          }`}
        />
      </div>
      {authCtx.loginReplyStates.isLoading && (
        <p>Loading...</p>
      )}
      {!authCtx.loginReplyStates.isLoading && (
        <p
          className={`${"error"} ${
            authCtx.loginReplyStates.error
          }`}
        >
          {authCtx.loginReplyStates.reply}
        </p>
      )}
      <div className={styles["form-actions"]}>
        <Button
          className={`${styles["login-button"]} ${
            formIsValid ? "" : styles["invalid"]
          }`}
          type="submit"
        >
          Login
        </Button>
      </div>

      <Button
        type="button"
        className={styles.signUp}
        onClick={clickSignUpHandler}
      >
        Don't have an account?
        <span> Sign up</span>
      </Button>
    </form>
  );
};

export default LoginForm;
